export enum SimulatorFeatureAppName {
  Range = 'range',
  Chargetime = 'chargetime',
  Cost = 'cost',
}

export enum NonSimulatorFeatureAppName {
  Tariffs = 'tariffs',
  LayerButton = 'layer-button',
  NaturalLanguage = 'natural-language',
}
